import React, { useEffect, useState } from "react";

//MUI
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from '@mui/material/CircularProgress';

import { API } from "../../config";
import { fnExcel, fni18n } from "../../services/commonService";
import {
    getAPI
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UDataGrid from "../../components/mui/UDataGrid";
import USelectBox from "../../components/mui/USelectBox";
import UTextField from "../../components/mui/UTextField";
import UButton from "../../components/mui/UButton";
import UDatePickers from "../../components/mui/UDatePickers";
import UTable from "../../components/mui/UTable";
import { theme } from '../../assets/themes';
import { makeStyles } from "@material-ui/core/styles";
import UTabs from "../../components/mui/UTabs";
import UAuthButton from "../../components/mui/UAuthButton";
import CloseIcon from '@mui/icons-material/Close';
import UPopupForm from "../../components/mui/UPopupForm";

import HistPopUpPage from './HistPopUpPage';


export default function HistPage(){
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [branchs, setBranch] = useState([]);
    const [transType, setTransType] = useState([]);
    const [depWitd, setDepWitd] = useState([]);
    const [userGroups, setUserGroups] = useState([]);
    const now = new Date().toISOString().slice(0, 10); 
    const [formOpen, setFormOpen] = useState(false); // modify dialog
    const [search, setSearch] = useState({
        startDate: now,
        endDate: now,
        // ,pageNum: "1"
        // ,machId:""
        // ,transType:""
        // ,trnsctSeq:""
        // ,userId:""
        // ,bizTy:""
        // ,storeCd:"N/A"
        // ,brandCd:"N/A"
    });
    const [rows, setRows] = useState([]);       //지점
    const [machineList, setMachineList] = useState([]);      
    const [selectedRow, setSelectedRow] = useState([]);
    const [brands, setBrands] = useState([]);
    const [loading, setLoading] = useState(false);        // 로딩바
    const [retailers, setRetailers] = useState([]);
    
    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            await Promise.all([
                loadComboBoxBranchGroup(),
                loadComboBoxBranch(),
                loadComboBoxTransType()
            ]);
        } catch (e) {
            console.error('초기 로딩 실패:', e.message);
        }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.storeCd) {
            loadDataGrid(); 
            setIsFirstLoad(false);
        }
    }, [search]);

    const columns = [
        {
            field: 'id',
            headerName: 'No',
            hide: true
        },
        {
            field: 'tid',
            headerName: 'tid',
            hide: true
        },
        {
            field: 'trnsctDateTime',
            headerName: '일자',
            width: 150,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: 'storeNm',
            headerName: '지점',
            width: 120,
            editable: false,
            align: "center",
            headerAlign: "center",
            // hide:true,
        },
        {
            field: 'brandNm',
            headerName: '브랜드',
            width: 120,
            editable: false,
            align: "center",
            headerAlign: "center"
        },
        {
            field: 'machId',
            headerName: '기기번호',
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center"
        },
        {
            field: 'userId',
            headerName: '사용자ID',
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center"
        },
        {
            field: 'trnsctKndCdnm',
            headerName: '거래유형',
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.rows.ioKndCd == "01" || params.rows.ioKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center", color:"red"}}>
                    {params.value}</div>;
                }      
            }
        },
        {
            field: 'trnsctSeq',
            headerName: '거래번호',
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.rows.ioKndCd == "01" || params.rows.ioKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center", color:"red"}}>
                    {params.value}</div>;
                }      
            }
            
        },
        {
            field: 'ioKndNm',
            headerName: 'Depo / Withd',
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            hide: true,
        },
        {
            field: 'userNm',
            headerName: 'User Name',
            width: 120,
            editable: false,
            align: "center",
            headerAlign: "center",
            hide: true,
        },
        {
            field: 'grpNm',
            headerName: 'User Group',
            width: 120,
            editable: false,
            align: "center",
            headerAlign: "center",
            hide: true,
        },
        //Bill
        {
            field: 'billTotal',
            headerName: '지폐금액',
            width: 50,
            editable: false,
            align: "right",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.rows.ioKndCd == "01" || params.rows.ioKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"right", color:"red"}}>
                    {params.value}</div>;
                }      
            }
        },
        //Coin
        {
            field: 'coinTotal',
            headerName: '동전금액',
            width: 100,
            editable: false,
            align: "right",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.rows.ioKndCd == "01" || params.rows.ioKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"right", color:"red"}}>
                    {params.value}</div>;
                }                
            }
        },
        //Check
        {
            field: 'checkTotal',
            headerName: '수표금액',
            width: 100,
            editable: false,
            align: "right",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.rows.ioKndCd == "01" || params.rows.ioKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"right", color:"red"}}>
                    {params.value}</div>;
                }                
            }
        },
        {
            field: 'total',
            headerName: '총금액',
            width: 120,
            editable: false,
            align: "right",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if (params.rows.ioKndCd == "01" || params.rows.ioKndCd == "02"){
                    return params.value;
                }else{
                    return <div style={{height:"100%", display:"flex", alignItems:"center", justifyContent:"right", color:"red"}}>
                    {params.value}</div>;
                }                
            }
        },
        {
            field: 'jnl',
            headerName: '저널',
            align: "center",
            headerAlign: "center",
            renderCell: (params) =>
            (
            <UButton variant="outlined" onButtonClick={(e)=>onButtonClick('journal',params)}>보기</UButton>
            ),
        },
    ];
    
     const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['storeCd']: 'N/A',
        });
        setMachineList([]);
        setBrands([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBranch = async(param) => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param,});
            const _inputData = res.data.result.map((m) => ({
                     cd: m.storeCd,
                     name: m.storeNm,
                 })
            );
            setBranch(_inputData );
            if (_inputData.length > 0){
                await getMachineList(_inputData[0].cd);
                await loadComboBoxBrand(_inputData[0].cd);
            } else{
                clearSearchVal()
            }
        }catch(e){
            console.error(e.message);
        }
    };
    // 기번 가져오기
    const getMachineList = async(param) => {
        try{
            let res = await getAPI(API.COMMON.MACHINE+param);
            let data = res.data.result.map((m) => ({
                    cd:m.machId,
                    name:m.machId,
                })
            );
            setMachineList(data);
        }catch(e){
            console.log("[TotalPage.jsx] getMachineList() Exception => "+e.message);
        }
    };

    const loadComboBoxTransType = async() => {
        try{
            const res = await getAPI(API.COMMON.TRANS_TYPE);
            const _inputData = res.data.result
                .filter((m) => /^AP[1-3]/.test(m.cd))   // m.cd가 AP1(입금), AP2(출금), AP3(교환)으로 시작하는 값만 필터링
                .map((m) => ({
                        cd: m.cd,
                        name: m.cdNm,
                    })
                );
            setTransType(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxDepWitd = async() => {
        try{
            const res = await getAPI(API.COMMON.IN_OUT);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.cd,
                    name: m.cdNm,
                })
            );
            setDepWitd(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxUserGroup = async() => {
        try{
            const res = await getAPI(API.COMMON.USER_GROUP);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.grpCd,
                    name: m.grpNm,
                })
            );
            setUserGroups(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const loadComboBoxBrand = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.BRAND, { userId: userLoginId, branch: branch});
            const _inputData = res.data.result.map((m) => ({
                    cd: m.brandCd,
                    name: m.brandNm,
                })
            );
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ['brandCd'] : _inputData[0].cd,
                    ['storeCd'] : branch,
                })
            } else {
                setSearch({
                    ...search,
                    ['brandCd'] : "N/A",
                    ['storeCd'] : branch,
                })
            }
            setBrands(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    //콤보박스 아이템 선택
    const onChangeCombo = (e) => {
        const { name, value } = e.target;

        setSearch({
          ...search,
          [name] : value === 'ALL' ? '' : value,
        });
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        if (name === "storeCd") {
            getMachineList(value);
            loadComboBoxBrand(value);
        }
    };

    //데이터그리드
    const loadDataGrid = () => {
        setLoading(true); //로딩바 시작
        getAPI(API.TRANS.HIST,search).then((res) => {
        const _inputData = res.data.result.map((rowData) => ({
            id: rowData.id,
            tid: rowData.tid,
            trnsctDateTime: rowData.trnsctDateTime,
            brandNm: rowData.brandNm,
            machId: rowData.machId,
            userId: rowData.userId,
            trnsctKndCdnm: rowData.trnsctKndCdnm + (rowData.offlineTrnsctYn === "Y" ? " (Offline)" : ""),
            trnsctSeq: rowData.trnsctSeq,
            ioKndNm: rowData.ioKndNm,
            userNm: rowData.userNm,
            grpNm: rowData.grpNm,
            billTotal: isNaN(rowData.billTotal)?"0":"$"+Number(rowData.billTotal).toLocaleString("en-US"),
            coinTotal: isNaN(rowData.coinTotal)?"0":Number(rowData.coinTotal).toLocaleString("en-US")+"¢",
            checkTotal: isNaN(rowData.checkTotal)?Number("0").toFixed(2):"$"+Number(rowData.checkTotal).toFixed(2).toLocaleString("en-US"),
            total: isNaN(rowData.total)?Number("0").toFixed(2):"$"+Number(rowData.total).toFixed(2).toLocaleString("en-US"),
            jnl: rowData.jnl,
            ioKndCd: rowData.ioKndCd,
            trnsctDt: rowData.trnsctDt,
            storeCd: rowData.storeCd,
            storeNm: rowData.storeNm,
            trnsctKndCd: rowData.trnsctKndCd,
            grpCd: rowData.grpCd,
            vaultCashCd: rowData.vaultCashCd,
            bill100Amt: rowData.bill100Amt,
            bill100Cnt: rowData.bill100Cnt,
            bill50Amt: rowData.bill50Amt,
            bill50Cnt: rowData.bill50Cnt,
            bill20Amt: rowData.bill20Amt,
            bill20Cnt: rowData.bill20Cnt,
            bill10Amt: rowData.bill10Amt,
            bill10Cnt: rowData.bill10Cnt,
            bill5Amt: rowData.bill5Amt,
            bill5Cnt: rowData.bill5Cnt,
            bill2Amt: rowData.bill2Amt,
            bill2Cnt: rowData.bill2Cnt,
            bill1Amt: rowData.bill1Amt,
            bill1Cnt: rowData.bill1Cnt,
            coin100Amt: rowData.coin100Amt,
            coin100Cnt: rowData.coin100Cnt,
            coin50Amt: rowData.coin50Amt,
            coin50Cnt: rowData.coin50Cnt,
            coin25Amt: rowData.coin25Amt,
            coin25Cnt: rowData.coin25Cnt,
            coin10Amt: rowData.coin10Amt,
            coin10Cnt: rowData.coin10Cnt,
            coin5Amt: rowData.coin5Amt,
            coin5Cnt: rowData.coin5Cnt,
            coin1Amt: rowData.coin1Amt,
            coin1Cnt: rowData.coin1Cnt,
            etcAmt: rowData.etcAmt,
            etcCnt: rowData.etcCnt,
            brandCd: rowData.brandCd,
        }));
        setRows(_inputData);
        setLoading(false); //로딩바 종료
      });
    }

    const onSelectedRows = (e, row) => {
    };
  
    function onButtonClick(dvsn,params){
        if(dvsn==="초기화"){
        }else if(dvsn==="조회"){
            let isSearch = true;
            const fromDate = new Date(search.startDate);
            const toDate = new Date(search.endDate);
            if (fromDate> toDate) {
                alert('시작일자가 종료일자 이후입니다. 입력 시작일자-('+search.startDate+")\n" + 'The start date is after the end date. Input start date-('+search.startDate+")")
                isSearch = false
            }
            let diff = Math.abs(toDate.getTime() - fromDate.getTime());
            diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

            if (diff > 90) {
                alert('최대 90일의 데이터를 확인하실 수 있습니다.(You can check up to 90 days of data.)')
                isSearch = false
            }

            if (isSearch) {
                loadDataGrid(search);
            }
        }else if(dvsn==="journal"){
            setSelectedRow(params.rows);
            setFormOpen(true);
        }
    };

    const onSearchChange = (e) => {
        let {name, value} = e.target;
        setSearch({
            ...search,
            [name] : value==='ALL'?'':value,
        })
    };
    
    //폼 팝업
    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };

    return(
        <div className={`main-container ${loading ? 'loading' : ''}`}>
            <Box className="header">
                <Grid container>
                    <Grid item xs={10}>
                        {/* 상단메뉴명 */}
                        <UBreadCrumbs
                            title={"거래정보"}
                            subtitle={"거래내역"}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        {/* 툴바 버튼 */}
                        <Stack 
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            spacing={4}
                        >
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
            
            {/* 검색부 */}
            <Box className="contents">
                <TableContainer className="table-container">
                <Table className="table" size="small">
                    <TableBody>
                        <TableRow className="table-row-header">
                            <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox
                                    name="bizTy"
                                    items={retailers}
                                    onItemChange={onChangeCombo}
                                />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox id="storeCd" name="storeCd" items={branchs} onItemChange={onChangeCombo} 
                                defaultValue={search.storeCd}
                                />
                            </TableCell>

                            <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox id="machId" name="machId" items={machineList} onItemChange={onChangeCombo}/>
                            </TableCell>

                            <TableCell className="table-cell-title">{fni18n('일자')}</TableCell>
                            <TableCell className="table-cell" colSpan={3} >
                                <UDatePickers onChange={onSearchChange} />
                            </TableCell>
                        </TableRow>
                        <TableRow className="table-row-header">
                            <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox id="brandCd" name="brandCd" items={brands} onItemChange={onChangeCombo} 
                                defaultValue={search.brandCd}
                                />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('거래번호')}</TableCell>
                            <TableCell className="table-cell">
                                <UTextField id="transNo" name="trnsctSeq" onChange={onChangeCombo}/>
                            </TableCell>

                            <TableCell className="table-cell-title">{fni18n('거래유형')}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox id="Trans" name="transType" items={transType} onItemChange={onChangeCombo}/>
                            </TableCell>

                            <TableCell className="table-cell-title">{fni18n('사용자ID')}</TableCell>
                            <TableCell className="table-cell" colSpan={3}>
                                <UTextField id="userId" name="userId" onChange={onSearchChange}/>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
                 <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                </div>
            
                {/* 조회 리스트 */}
                <UTable tablabel={"거래1"} columns={columns} rows={rows} rowPerPage={10} onSelectedRowChange={onSelectedRows} 
                />
            </Box>

            {/* 팝업 */}
            <UPopupForm
                    title={"저널 상세"}
                    open={formOpen}
                    onClose={handleFormClose}
                    content={<HistPopUpPage data={selectedRow} />}
                    type={"1"}
                    maxWidth={"xl"}
                />
            {/* loading box */}
            <Box sx={{ 
                display: loading ? 'flex' : 'none',
                justifyContent: 'center', 
                alignItems: 'center', 
                width: '100%', 
                height: '100%', 
                top: 0, 
                left: 0, 
                position: 'fixed', 
                bgcolor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 9999,
                }}>
                {loading && <CircularProgress color="inherit" size={150}/>}
            </Box>
        </div>
    );
}